import { useTheme } from '@mui/material';

export const NewStudyIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none">
            <path
                fill={primaryStroke}
                d="M10 36h28v-7.756L37.937 28H31.62l-1.725 3.45-.275.55H18.38l-.275-.55L16.381 28h-6.319l-.062.244V36Zm27.438-10-3.5-14H14.061l-3.5 14h7.059l.275.55L19.619 30h8.762l1.725-3.45.275-.55h7.057ZM8 36v-8l4.5-18h23L40 28v10H8v-2Z"
            />
        </svg>
    );
};
